export const color = '#2185d0'

export const colors = {
  primary: '#2185d0',
  footer: '#061723',
}

export const siteWidth = '567'
export const PAGE_MAX_WIDTH = '819px'
